import React from "react";
import {
  StyleSheet,
  View,
  Modal,
  TouchableWithoutFeedback,
  TouchableOpacity,
  Image,
} from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import LostDamageModalImage from "@assets/images/lostdamagemodal.png";

const LostDamageModal = ({ showModal, setShowModal, modalText }) => (
  <Modal visible={showModal} animationType="slide" transparent>
    <TouchableWithoutFeedback
      onPress={() => {
        setShowModal(false);
      }}
    >
      <View style={styles.modalOverlay} />
    </TouchableWithoutFeedback>
    <View style={styles.modalContent}>
      <View style={styles.modalInnerContent}>
        <Image
          source={LostDamageModalImage}
          style={styles.modalImage}
          resizeMode="center"
        />
        <Text variant="body_text_2" style={{ color: color.plain_red }}>
          {modalText}
        </Text>
        <TouchableOpacity
          testID="ldm-ok-button"
          style={styles.modalBtn}
          onPress={() => setShowModal(false)}
        >
          <Text variant="body_text_4">ठीक है</Text>
        </TouchableOpacity>
      </View>
    </View>
  </Modal>
);

export default LostDamageModal;

const styles = StyleSheet.create({
  modalOverlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    flex: 1,
  },
  modalContent: {
    backgroundColor: "#fff",
    borderRadius: 16,
    width: "90%",
    position: "absolute",
    top: "30%",
    left: "5%",
  },
  modalInnerContent: {
    padding: 16,
    alignItems: "center",
  },
  modalBtn: {
    borderRadius: 16,
    borderColor: color.black,
    borderWidth: 1,
    alignItems: "center",
    width: "50%",
    paddingVertical: 12,
    marginVertical: 12,
  },
  modalImage: {
    height: 81,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    marginBottom: 8,
    right: 5,
  },
});
